import { render, staticRenderFns } from "./TaskCommentNotificationModal.vue?vue&type=template&id=b8fb9c1e&"
import script from "./TaskCommentNotificationModal.vue?vue&type=script&lang=js&"
export * from "./TaskCommentNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports